import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { LiquidityTokenMinterFactory } from "../codegen/LiquidityTokenMinterFactory";
import { isEthNetwork, LiquidityTokenMinterAddress, } from "../constants/constants";
import { useETHWeb3Context } from "./web3Context";
export var getLiquidityTokenMinter = function (library, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    var provider = useSigner ? library.getSigner() : library;
    return LiquidityTokenMinterFactory.connect(LiquidityTokenMinterAddress, provider);
};
var useLiquidityTokenMinter = function () {
    var _a = useWeb3React(), active = _a.active, chainId = _a.chainId, library = _a.library;
    var provider = useETHWeb3Context().provider;
    var _b = useState(null), contract = _b[0], setContract = _b[1];
    useEffect(function () {
        if (active && chainId && isEthNetwork(chainId)) {
            setContract(getLiquidityTokenMinter(library, active));
            return;
        }
        setContract(getLiquidityTokenMinter(provider, false));
    }, [provider, chainId, active, library]);
    return contract;
};
export default useLiquidityTokenMinter;
//# sourceMappingURL=useLiquidityTokenMinter.js.map